import { render, staticRenderFns } from "./purreceiveview.vue?vue&type=template&id=ce62dfda&scoped=true&"
import script from "./purreceiveview.vue?vue&type=script&lang=js&"
export * from "./purreceiveview.vue?vue&type=script&lang=js&"
import style0 from "./purreceiveview.vue?vue&type=style&index=0&id=ce62dfda&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce62dfda",
  null
  
)

export default component.exports